import PropTypes from 'prop-types';
import merge from 'lodash/merge';

import Chart from '../../charts/Chart';
import 'highcharts/highcharts-more';

import { lineChartConfiguration, setModifiedData } from './utilities/helpers';

const LineChart = ({
  onChartCallback = () => {},
  prescriptText = null,
  series,
  xAxis,
  yAxis,
  ...props
}) => {
  return (
    <Chart
      onChartCallback={onChartCallback}
      options={merge({}, lineChartConfiguration, { series, type: 'line', xAxis, yAxis, ...props })}
      prescriptText={prescriptText}
      setModifiedData={setModifiedData}
      {...props}
    />
  );
};

LineChart.propTypes = {
  onChartCallback: PropTypes.func,
  prescriptText: PropTypes.node,
  series: PropTypes.array,
  xAxis: PropTypes.object,
  yAxis: PropTypes.object,
};

export default LineChart;
